// extracted by mini-css-extract-plugin
export default {"fullScreenLoader":"FullPageLoader_fullScreenLoader__odtAf","spinner":"FullPageLoader_spinner__cvGn5","rotation":"FullPageLoader_rotation__jWXZw"};